/** Reserve the warning's actual height so translated or wrapped text cannot cover the welcome panel. */
export function createBillingWarningLayout() {
  let observer: ResizeObserver | undefined;
  const clear = () => {
    observer?.disconnect();
    document.documentElement?.classList.remove('has-billing-warning');
    document.documentElement?.style.removeProperty('--billing-warning-height');
  };
  return {
    update(host: HTMLElement) {
      clear();
      const warning = host.querySelector<HTMLElement>('#billing-warning');
      if (!warning) return;
      const measure = () => document.documentElement?.style.setProperty('--billing-warning-height', `${warning.getBoundingClientRect().height}px`);
      document.documentElement?.classList.add('has-billing-warning');
      measure();
      if ('ResizeObserver' in globalThis) {
        observer = new ResizeObserver(measure);
        observer.observe(warning);
      }
    },
    disconnect: clear,
  };
}
